<template>
  <div class="reverse-tracking" style="width:100%;heigh:100%;">
    <div class="table_searchbar">
      <el-row :gutter="20">
        <el-col :span="5">
          <div class="">
            <span class="title">采购单号：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              @clear="purchaseRemoteMethod"
              :remote-method="purchaseRemoteMethod"
              remote="remote"
              :loading="loading"
              @change="purchaseSelectChange($event)"
              v-model="searchForm.purchaseId"
              clearable
              placeholder="采购单号"
              filterable
            >
              <el-option v-for="(item, index) in purchaseList" :key="index + Math.random()" :label="item.purchaseCode" :value="item.purchaseId"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="">
            <span class="title">物料编码：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              @clear="materialRemoteMethod"
              :remote-method="query => this.materialRemoteMethod('', query)"
              remote="remote"
              :loading="loading"
              @change="materialSelectChange($event)"
              v-model="searchForm.materialId"
              clearable
              placeholder="物料编码"
              filterable
            >
              <el-option v-for="(item, index) in materialList" :key="index + Math.random()" :label="item.materialCode" :value="item.materialId"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="">
            <span class="title">物料名称：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              @clear="materialRemoteMethod"
              :remote-method="query => this.materialRemoteMethod(query)"
              remote="remote"
              :loading="loading"
              @change="materialSelectChange($event)"
              v-model="searchForm.materialId"
              clearable
              placeholder="物料名称"
              filterable
            >
              <el-option v-for="(item, index) in materialList" :key="index + Math.random()" :label="item.materialName" :value="item.materialId"></el-option>
            </el-select>
          </div>
        </el-col>

        <el-col :span="5">
          <div class="">
            <span class="title">批次号：</span>
            <el-select
              size="small"
              style="max-width:180px;"
              @clear="arrivalRemoteMethod"
              remote
              :remote-method="arrivalRemoteMethod"
              :loading="loading"
              @change="arrivalSelectChange($event)"
              v-model="searchForm.arrivalId"
              clearable
              placeholder="批次号"
              filterable
            >
              <el-option v-for="(item, index) in arrivalList" :key="index + Math.random()" :label="item.arrivalCode" :value="item.arrivalId"></el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="4">
          <div style="text-align:right">
            <el-button size="mini" :disabled="!searchForm.arrivalId" icon="el-icon-search" type="primary" @click="btnSearch">查询</el-button>
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row :gutter="20">
      <el-col :span="4" class="left-border">
        <span class="bom-title">物料bom结构</span>
        <el-tree
          ref="tree"
          :default-expand-all="true"
          node-key="id"
          class="tree-list"
          :default-expanded-keys="[selecTree]"
          :current-node-key="selecTree"
          highlight-current
          accordion
          :data="materialTree"
          :expand-on-click-node="false"
          :props="defaultProps"
          @node-click="handleNodeClick"
        >
        </el-tree>
      </el-col>

      <el-col :span="20">
        <el-tabs type="border-card" class="eltabs" v-model="activeName" @tab-click="itemChange">
          <el-tab-pane label="批次物料" name="batchMaterialDtos">
            <el-table :data="batchMaterialDtos" :maxHeight="710">
              <el-table-column prop="materialCode" label="物料编码"></el-table-column>
              <el-table-column prop="materialName" label="物料名称"></el-table-column>
              <el-table-column prop="specification" label="规格"></el-table-column>
              <el-table-column prop="batchCode" label="批次号"></el-table-column>
              <el-table-column prop="productionStartTime" label="生产开始时间"></el-table-column>
              <el-table-column prop="productionEndTime" label="生产结束时间"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="原材料信息" name="rawMaterialDtos">
            <el-table :data="rawMaterialDtos" :maxHeight="710">
              <el-table-column prop="materialCode" label="物料编码"></el-table-column>
              <el-table-column prop="materialName" label="物料名称"></el-table-column>
              <el-table-column prop="specification" label="规格"></el-table-column>
              <el-table-column prop="supplier" label="供应商"></el-table-column>
              <el-table-column prop="batchCode" label="批次"></el-table-column>
              <el-table-column prop="amount" label="数量"></el-table-column>
              <el-table-column prop="inspectionStatus" label="来料检验结果" :formatter="parseInspectionStatus"></el-table-column>
              <el-table-column prop="stockInTime" label="入库时间"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="生产过程" name="productiveProcessDtos">
            <el-table :data="productiveProcessDtos" :maxHeight="710">
              <el-table-column prop="procedureName" label="工序名称"></el-table-column>
              <el-table-column prop="workerName" label="执行人"></el-table-column>
              <el-table-column prop="deviceName" label="加工设备"></el-table-column>
              <el-table-column prop="finishedAmount" label="完成数量"></el-table-column>
              <el-table-column prop="startTime" label="开始时间"></el-table-column>
              <el-table-column prop="endTime" label="结束时间"></el-table-column>
              <el-table-column prop="hours" label="实际加工工时"></el-table-column>
            </el-table>
          </el-tab-pane>

          <el-tab-pane label="检验信息" name="qcTaskDtos">
            <el-table :data="qcTaskDtos" :maxHeight="710">
              <el-table-column prop="qcTaskCode" label="检验单号"></el-table-column>
              <el-table-column prop="procedureName" label="工序名称"></el-table-column>
              <el-table-column prop="inspectCount" label="质检数量"></el-table-column>
              <el-table-column prop="unQualifiedCount" label="不合格数量"></el-table-column>
              <!-- <el-table-column prop="scrapCount" label="报废数量"></el-table-column> -->
              <el-table-column prop="qualificationRate" label="合格率"></el-table-column>
              <el-table-column prop="qualityInspector" label="质检人"></el-table-column>
              <el-table-column prop="inspectType" :formatter="parseQcType" label="质检类型"></el-table-column>
              <el-table-column prop="checkDate" label="质检时间"></el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "ReverseTracking",
  data() {
    return {
      resultOption: [
        { label: "合格", value: 0 },
        { label: "不合格退回", value: 1 },
        { label: "特采", value: 2 }
      ],
      defaultProps: {
        children: "son",
        label: "materialName"
      },
      splitIds: [],
      materialTree: [],
      map: {
        batchMaterialDtos: 1,
        rawMaterialDtos: 2,
        productiveProcessDtos: 3,
        qcTaskDtos: 4
      },
      isNodeClick: false,
      materialList: [],
      arrivalList: [],
      purchaseList: [],
      tracesType: 1,
      splitList: [],
      loading: false,
      orderOptions: [],
      selecTree: 1,
      batchMaterialDtos: [],
      rawMaterialDtos: [],
      productiveProcessDtos: [],
      qcTaskDtos: [],
      activeName: "batchMaterialDtos",
      fristLoad: false,
      W: false,
      searchForm: {
        purchaseId: null,
        materialId: null,
        arrivalId: null
      },
      data: {
        token: localStorage.getItem("token")
      },
      typeOption: [
        { label: "母卷质量检", value: 1 },
        { label: "自检", value: 4 },
        { label: "子卷质量检", value: 3 },
        { label: "终检", value: 2 },
        { label: "其它", value: 5 }
      ],
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },

  components: {},
  mounted: async function() {
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    this.materialList = await this.loadMaterialList();
    this.purchaseList = await this.loadPurchaseList();
    this.arrivalList = await this.loadArrivalList();
  },

  computed: {
    span() {
      return this.W ? 5 : 7;
    }
  },

  methods: {
    async loadMaterialList(materialName, materialCode) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listPurchaseMaterial", type: "sync", params: { materialName, materialCode } });
      return data;
    },

    async loadPurchaseList(materialId, purchaseCode) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listPurchaseCode", type: "sync", params: { materialId, purchaseCode } });
      return data;
    },

    async loadArrivalList(purchaseId, materialId, arrivalCode) {
      let { data } = await this.$RequestUtil.getAsync({ url: "/api/select/listArrivalPurchaseDto", type: "sync", params: { purchaseId, materialId, arrivalCode } });
      return data;
    },

    async purchaseRemoteMethod(query) {
      this.loading = true;
      let data = await this.loadPurchaseList(this.searchForm.materialId, query);
      this.searchForm.materialId = null;
      this.materialList = commonUtils.cloneObj(data);
      this.purchaseList = data;
      this.loading = false;
    },

    async purchaseSelectChange(ev) {
      if (ev) {
        let find = this.purchaseList.find(item => item.purchaseId == ev) || {};
        this.searchForm.materialId = find.materialId;
        this.materialList = [find];
      }
      this.arrivalList = await this.loadArrivalList(ev, this.searchForm.materialId);
    },

    async materialRemoteMethod(materialName, materialCode) {
      this.loading = true;
      this.materialList = await this.loadMaterialList(materialName, materialCode);
      this.loading = false;
    },

    async materialSelectChange(ev) {
      this.purchaseList = await this.loadPurchaseList(ev);
      this.arrivalList = await this.loadArrivalList(null, ev);
      this.searchForm.purchaseId = null;
      this.searchForm.arrivalId = null;
    },

    async arrivalRemoteMethod(query) {
      this.loading = true;
      let data = await this.loadArrivalList(this.searchForm.purchaseId, this.searchForm.materialId, query);
      this.searchForm.materialId = null;
      this.searchForm.purchaseId = null;
      this.materialList = commonUtils.cloneObj(data);
      this.purchaseList = commonUtils.cloneObj(data);
      this.arrivalList = data;
      log(data, this.materialList, this.purchaseList, this.arrivalList, 8888);
      this.loading = false;
    },

    async arrivalSelectChange(ev) {
      let find = this.arrivalList.find(item => item.arrivalId == ev) || {};
      this.materialList = [find];
      this.purchaseList = [find];
      this.searchForm.materialId = find.materialId;
      this.searchForm.purchaseId = find.purchaseId;
    },

    handleNodeClick({ splitIds }) {
      this.isNodeClick = true;
      this.splitIds = splitIds;
      this.search();
    },

    itemChange() {
      this.tracesType = this.map[this.activeName];
      if (!this.searchForm.arrivalId && !this.searchForm.materialId) {
        return;
      }
      this.search();
    },

    btnSearch() {
      this.splitIds = [];
      this.isNodeClick = false;
      this.search();
    },

    clearSearch() {
      let form = this.searchForm;
      form.materialId = null;
      form.purchaseId = null;
      form.arrivalId = null;
    },

    search: function() {
      let arrivalNoticeId = this.searchForm.arrivalId;
      if (this.isNodeClick) {
        arrivalNoticeId = null;
      }
      this.$RequestUtil.post({
        url: "/api/productionTraceability/backwardTracing",
        type: "sync",
        params: {
          splitIds: this.splitIds,
          tracesType: [this.tracesType],
          arrivalNoticeId,
          materialId: this.searchForm.materialId
        },
        success: res => {
          if (res.code == 0) {
            if (!this.isNodeClick) {
              this.materialTree = res.data.billOfMaterialsDtos;
            }
            this.batchMaterialDtos = res.data.batchMaterialDtos;
            this.rawMaterialDtos = res.data.rawMaterialDtos;
            this.productiveProcessDtos = res.data.productiveProcessDtos;
            this.qcTaskDtos = res.data.qcTaskDtos;
            this.fristLoad = true;
          } else {
            this.$message.error(res.message || res.msg);
          }
        }
      });
    },

    parseInspectionStatus(rowData) {
      if (rowData.inspectionResult === null) {
        return "";
      }
      let num = Number(rowData.inspectionResult);
      return (this.resultOption.find(item => item.value == num) || {}).label;
    },

    parseQcType(rowData) {
      let num = Number(rowData.inspectType);
      let str = "";
      this.typeOption.forEach(item => {
        if (item.value == num) {
          str = item.label;
        }
      });
      return str;
    }
  }
};
</script>

<style scoped>
/* .tree-list{
        width: 380px;
    } */

.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}

.title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}
.left-border {
  height: 710px;
  border: 1px solid #b4bccc;
  border-radius: 4px;
}
.bom-title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  margin-left: -4px;
  line-height: 34px;
  line-height: 34px;
  font-weight: 600;
}

.add_form .value {
  display: inline-block;
}

.el-row {
  margin-bottom: 20px;

  & :last-child {
    margin-bottom: 0;
  }
}

.table_searchbar {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}

.import_upload {
  display: inline;
}

.page {
  display: flex;
  justify-content: flex-end;
}

@media screen and (max-width: 1450px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}

.total_page {
  margin-top: 14px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
.reverse-tracking .el-tree > .el-tree-node {
  margin-bottom: 30px;
}
.reverse-tracking .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #409eff;
  color: #fff;
}

.reverse-tracking .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #409eff;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/productTracking/ReverseTracking.vue